import React from "react";
import { MainContainer } from "./style";
import { useState } from "react";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Button, Grid, MenuItem, Typography, Box } from "@mui/material";
import FieldErrorMessage from "../../../../components/common-components/FieldErrorMessage";
import { CustomPhoneInput } from "../../../../components/common-components/CustomPhoneInput";
import { CustomTextField } from "../../../../components/common-components/CustomTextField";
import {
  CustomSelect,
  CustomSelectField,
} from "../../../../components/common-components/CustomSelect";
import { StyledCircularProgress } from "../../jd-resume/reports/style";

import useCreateRecruiters from "./useCreateRecruiters";

const CreateRecruiter = () => {
  const {
    formik,
    roles,
    validatePhoneNumber,
    phoneErrorMessage,
    isSubmitting,

    setOnChangeValidation,
  } = useCreateRecruiters();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  return (
    <MainContainer>
      <Box className="page-card">
        <Box className="page-header">
          <Typography className="page-title">Create Recruiter</Typography>
          <Typography className="page-subtitle">
            Fill in the recruiter details below to create a new recruiter
            account.
          </Typography>
        </Box>

        <form onSubmit={formik.handleSubmit} autoComplete="off">
          <Grid container spacing={3} className="form-grid">
            <Grid item xs={12} md={6}>
              <Box className="field-block">
                {/* <Typography className="field-label">Name</Typography> */}
                <CustomTextField
                  className="required_field"
                  fullWidth
                  label="Name"
                  placeholder="Enter recruiter name"
                  variant="outlined"
                  id="name"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  disabled={isSubmitting}
                  inputProps={{ autoComplete: "off" }}
                  autoComplete="off"
                />
                <FieldErrorMessage error={formik.errors.name} />
              </Box>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Box className="field-block">
                {/* <Typography className="field-label">Email</Typography> */}
                <CustomTextField
                  className="required_field"
                  fullWidth
                  label="Email"
                  placeholder="Enter email address"
                  variant="outlined"
                  id="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  disabled={isSubmitting}
                  inputProps={{ autoComplete: "off" }}
                  autoComplete="off"
                />
                <FieldErrorMessage error={formik.errors.email} />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box className="field-block">
                {/* <Typography className="field-label">Phone Number</Typography> */}
                <Box className="custom-phone-input">
                  <CustomPhoneInput
                    country={"us"}
                    value={formik.values.phone_number}
                    onChange={(phone, country) => {
                      validatePhoneNumber(phone, country);
                    }}
                    inputStyle={{
                      width: "100%",
                    }}
                    inputProps={{
                      name: "phone_number",
                      id: "phone_number",
                      autoComplete: "off",
                    }}
                    disabled={isSubmitting}
                  />
                </Box>
                <FieldErrorMessage
                  error={
                    formik.errors.phone_number
                      ? formik.errors.phone_number
                      : phoneErrorMessage
                  }
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box className="field-block">
                {/* <Typography className="field-label">Title</Typography> */}
                <CustomTextField
                  className="required_field"
                  fullWidth
                  label="Title"
                  placeholder="Enter title"
                  variant="outlined"
                  id="title"
                  name="title"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  disabled={isSubmitting}
                  inputProps={{ autoComplete: "off" }}
                  autoComplete="off"
                />
                <FieldErrorMessage error={formik.errors.title} />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box className="field-block">
                {/* <Typography className="field-label">Password</Typography> */}
                <CustomTextField
                  className="required_field"
                  fullWidth
                  label="Password"
                  placeholder="Enter password"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  disabled={isSubmitting}
                  inputProps={{ autoComplete: "new-password" }}
                  autoComplete="new-password"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <FieldErrorMessage error={formik.errors.password} />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box className="field-block">
                {/* <Typography className="field-label"> */}
                {/* Confirm Password
                </Typography> */}
                <CustomTextField
                  className="required_field"
                  fullWidth
                  label="Confirm Password"
                  placeholder="Confirm password"
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirm_password"
                  name="confirm_password"
                  value={formik.values.confirm_password}
                  onChange={formik.handleChange}
                  disabled={isSubmitting}
                  inputProps={{ autoComplete: "new-password" }}
                  autoComplete="new-password"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            setShowConfirmPassword((prev) => !prev)
                          }
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <FieldErrorMessage error={formik.errors.confirm_password} />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box className="field-block">
                {/* <Typography className="field-label">Role</Typography> */}
                <CustomSelect
                  options={roles}
                  getOptionLabel={(option) => option.label}
                  value={
                    roles.find((role) => role.value === formik.values.role) ||
                    null
                  }
                  onChange={(event, value) => {
                    formik.setFieldValue("role", value ? value.value : "");
                  }}
                  disabled={isSubmitting}
                  renderInput={(params) => (
                    <CustomSelectField
                      {...params}
                      label="Role"
                      variant="outlined"
                      error={formik.errors.role}
                    />
                  )}
                  renderOption={(props, option) => (
                    <MenuItem {...props} className="role-menu-item">
                      {option.label || ""}
                    </MenuItem>
                  )}
                />
                <FieldErrorMessage error={formik.errors.role} />
              </Box>
            </Grid>
          </Grid>

          <Box className="form-actions">
            {isSubmitting ? (
              <Button className="btn creating-btn" variant="contained">
                Creating
                <StyledCircularProgress size={18} />
              </Button>
            ) : (
              <Button
                className="btn"
                variant="contained"
                type="submit"
                onClick={() => setOnChangeValidation(true)}
              >
                Create Recruiter
              </Button>
            )}
          </Box>
        </form>
      </Box>
    </MainContainer>
  );
};

export default CreateRecruiter;
